export type ApprovalLaborEvaluation = {
  workedMinutes: number;
  totalOvertimeMinutes: number;
  eventIssues: unknown[];
  mealIssueCount: number;
  secondMealReviewCount: number;
};

export function splitApprovalPeriod(from: string, to: string) {
  const end = new Date(`${to}T00:00:00Z`),
    ranges: { from: string; to: string }[] = [];
  for (
    let start = new Date(`${from}T00:00:00Z`);
    start <= end;
    start = new Date(start.getTime() + 7 * 86400000)
  )
    ranges.push({
      from: start.toISOString().slice(0, 10),
      to: new Date(Math.min(start.getTime() + 6 * 86400000, end.getTime()))
        .toISOString()
        .slice(0, 10),
    });
  return ranges;
}

export function summarizeApprovalLabor(
  evaluations: ApprovalLaborEvaluation[],
) {
  return evaluations.reduce(
    (summary, item) => ({
      workedMinutes: summary.workedMinutes + item.workedMinutes,
      totalOvertimeMinutes:
        summary.totalOvertimeMinutes + item.totalOvertimeMinutes,
      eventIssueCount: summary.eventIssueCount + item.eventIssues.length,
      mealIssueCount: summary.mealIssueCount + item.mealIssueCount,
      secondMealReviewCount:
        summary.secondMealReviewCount + item.secondMealReviewCount,
    }),
    {
      workedMinutes: 0,
      totalOvertimeMinutes: 0,
      eventIssueCount: 0,
      mealIssueCount: 0,
      secondMealReviewCount: 0,
    },
  );
}

export function approvedLeaveHours(
  rows: { hoursHundredths: number }[],
) {
  return (
    rows.reduce(
      (total, item) => total + Number(item.hoursHundredths || 0),
      0,
    ) / 100
  );
}
